import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { TabCardApplicationContent } from '@/components/payments/tab-card-application-content';
import { TabCardDetails } from '@/components/payments/types';
import { Typography } from '@usepepper/ui/atoms/typography';

export interface Props {
  onClose: () => void;
  tabCardDetails: TabCardDetails;
}

export const TabCardApplicationActionSheet: React.FC<Props> = ({
  onClose,
  tabCardDetails,
}) => {
  return (
    <BaseActionSheet
      headerContent={
        <Typography variant="heading-md">
          {i18n.t('tab_card_modal.header')}
        </Typography>
      }
      isVisible
      onClose={onClose}
    >
      <TabCardApplicationContent
        onAfterSignUp={onClose}
        tabCardDetails={tabCardDetails}
      />
    </BaseActionSheet>
  );
};
